<template>
  <div class="card">
    <div class="card-header padding_12_20">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <div class="me-3">
            <img src="@/assets/images/svg-img/fuel-mix.svg" />
          </div>
          <div>
            <div class="card_title_1">FUEL MIX (%)</div>
            <!-- <div class="card_title_2">Last Updated {{ last_update }}</div> -->
          </div>
        </div>
        <div></div>
      </div>
    </div>

    <div class="card-body thermal-mobile">
      <div class="row">
        <div class="card_title_2">
          Periode: {{ dataMonth }}, {{ dataYear }}
        </div>
        <div class="col-md-11">
          <div class="chart-section">
            <apexchart
              type="bar"
              width="100%"
              height="350"
              :options="barChartOptions"
              :series="fuelmix"
            ></apexchart>
          </div>
        </div>
        <div class="col-md-1">
          <div class="chart-legend">
            <div
              v-for="(item, index) in dataCheckbox.slice().reverse()"
              :key="index"
              class="d-flex flex-row-reverse align-items-center"
            >
              <div>
                <input
                  class="form-check-input custom_checkbox_revenue"
                  :style="{
                    backgroundColor: item.color,
                    borderColor: item.color,
                  }"
                  type="checkbox"
                  :value="item.id"
                  v-model="isChecked"
                />
              </div>
              <div class="custom_checkbox_texts">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GenerationService from "@/services/generation/generation";
const apiGeneration = GenerationService.build();

export default {
  props: [],
  data() {
    return {
      dataMonth: "",
      dataYear: "",
      dataTemp: [],
      isChecked: [],
      dataCheckbox: [],
      fuelmix: [],
      barSeries: [
        {
          name: "BBM",
          data: [44, 55, 41, 37, 22, 43, 21],
        },
        {
          name: "Batu Bara",
          data: [53, 32, 33, 52, 13, 43, 32],
        },
        {
          name: "Gas Alam",
          data: [12, 17, 11, 9, 15, 11, 20],
        },
        {
          name: "Panas Bumi",
          data: [9, 7, 5, 8, 6, 9, 4],
        },
        {
          name: "Air",
          data: [25, 12, 19, 32, 25, 24, 10],
        },
        {
          name: "EBT",
          data: [25, 12, 19, 32, 25, 24, 10],
        },
        {
          name: "Lainnya",
          data: [25, 12, 19, 32, 25, 24, 10],
        },
      ],
      barChartOptions: {
        chart: {
          type: "bar",
          height: 300,
          stacked: true,
          toolbar: {
            show: false,
          },
          dropShadow: {
            enabled: true,
            top: 8,
            left: 0,
            blur: 10,
            color: "#7064F5",
            opacity: 0.1,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "25px",
            borderRadius: 0,
          },
        },
        grid: {
          show: true,
          borderColor: "var(--chart-border)",
        },
        dataLabels: {
          enabled: false,
        },
        fill: {
          opacity: 1,
        },
        legend: {
          show: false,
          position: "right",
          horizontalAlign: "right",
          offsetX: 10,
        },

        states: {
          hover: {
            filter: {
              type: "darken",
              value: 1,
            },
          },
        },
        colors: [],
        yaxis: {
          labels: {
            show: true,
            style: {
              fontFamily: "Rubik, sans-serif",
            },
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          max: 100,
        },
        xaxis: {
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        states: {
          hover: {
            filter: {
              type: "darken",
              value: 1,
            },
          },
        },
        responsive: [
          {
            breakpoint: 1661,
            options: {
              chart: {
                height: 290,
              },
            },
          },
          {
            breakpoint: 767,
            options: {
              plotOptions: {
                bar: {
                  columnWidth: "35px",
                },
              },
              yaxis: {
                labels: {
                  show: false,
                },
              },
            },
          },
          {
            breakpoint: 481,
            options: {
              chart: {
                height: 300,
                width: "100%",
              },
              xaxis: {
                labels: {
                  rotate: -30,
                },
              },
            },
          },
          {
            breakpoint: 420,
            options: {
              chart: {
                height: 300,
                width: 700,
              },
              xaxis: {
                labels: {
                  rotate: -30,
                },
              },
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.getDataGenerationFuelMix();
  },
  watch: {
    isChecked(x) {
      const filter = this.dataTemp.filter((item) => x.includes(item.id));
      this.fuelmix = filter;
    },
  },
  methods: {
    getMonthName(monthNumber) {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      // Adjust for 0-based index (JavaScript arrays start at 0)
      return months[monthNumber - 1] || "Invalid month";
    },
    async getDataGenerationFuelMix() {
      const res = await apiGeneration.getDataGenerationFuelMix();
      if (res && res.status == 200) {
        // this.last_update = res.data.lastUpdate.match(/\d{2} \w+ \d{4}/)[0];
        const data = res.data.data.data;
        this.dataMonth = this.getMonthName(res.data.data.month);
        this.dataYear = res.data.data.year;
        const colors = [
          {
            id: "BBM",
            color: "#ff4d00", // BBM
          },
          {
            id: "Batu Bara",
            color: "#0f0f0f", // Batu Bara
          },
          {
            id: "Gas Alam",
            color: "#0800ff", // Gas Alam
          },
          {
            id: "Panas Bumi",
            color: "#34e5eb", // Panas Bumi
          },
          {
            id: "Air",
            color: "#125e03", // Air
          },
          {
            id: "EBT",
            color: "#2cc90c", // EBT
          },
          {
            id: "Lainnya",
            color: "#ff0090", // Lainnya
          },
        ];
        const fullData = data.map((item) => ({
          id: item.metricName,
          name: item.metricName,
          data: item.listItem,
          color: item.color,
        }));
        colors.forEach((colorObj) => {
          const item = fullData.find((d) => d.id === colorObj.id);
          if (item) {
            item.color = colorObj.color;
          }
        });
        this.fuelmix = fullData;
        this.dataTemp = fullData;
        this.dataCheckbox = fullData;
        const item = fullData.map((obj) => obj.id);
        this.isChecked = item;
      }
    },
  },
};
</script>
